const marketplace_tab_data = [
  {
    id: 0,
    title: "Block-Libraries",
    path: "/marketplace/block-libraries",
  },
  {
    id: 1,
    title: "Devices",
    path: "/marketplace/devices",
  },
];

export default marketplace_tab_data;
